import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["priceField"]

  toggle(event) {
    this.priceFieldTarget.classList.toggle("hidden", event.target.value !== "purchasable")
  }
}
